import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import AchievementsSection from "../../shared/AchievementsSection";
import Newsletter from "../../shared/Newsletter";

/*Tour ------------Card----------- Images*/
import tour1 from "./../../assets/images/short-tour2.jpg";
import tour2 from "./../../assets/images/bikaner.jpg";
import tour3 from "./../../assets/images/udaipur.jpg";
import tour4 from "./../../assets/images/ajmer.jpg";
import tour5 from "./../../assets/images/short-tour6.jpg";
import tour6 from "./../../assets/images/jaisalmer.jpg";
import tour7 from "./../../assets/images/bundi.jpg";
import tour8 from "./../../assets/images/ranakpur.jpg";
import tour9 from "./../../assets/images/barmer.jpg";
import tour10 from "./../../assets/images/shekhawati.jpg";
import tour11 from "./../../assets/images/dungarpur.jpg";
import tour12 from "./../../assets/images/bharatpur.jpg";
import tour13 from "./../../assets/images/karauli.jpg";
import tour14 from "./../../assets/images/jhalawar.jpg";
import tour15 from "./../../assets/images/dholpur.jpg";
import tour16 from "./../../assets/images/chittogarh.jpg";
import tour17 from "./../../assets/images/kumbhalpur.jpg";
import tour18 from "./../../assets/images/bhilwara.jpg";
import tour19 from "./../../assets/images/mountabu.jpg";
import tour20 from "./../../assets/images/jodhpur.jpg";
import TourCardBlock from "../../shared/TravelCardBlock";
import { Helmet } from "react-helmet";
import BookingMainPage from "../../components/Booking/BookingMainPage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Subtitle from "../../shared/Subtitle";
import ImageGallery from "../../components/Gallery/Gallery2";

const MainRajasthanTravel = () => {
  const images = [tour1, tour2, tour3, tour4, tour5, tour6, tour7];

  const [isMobile, setIsMobile] = useState(false);

  const updateIsMobile = () => {
    setIsMobile(window.innerWidth <= 786);
  };

  useEffect(() => {
    updateIsMobile(); // Initial check
    window.addEventListener("resize", updateIsMobile);

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const tourData = [
    {
      name: "Jaipur",
      category: "Rajasthan",
      city: "Rajasthan",
      image: tour1,
      featured: true,
      reviews: 4.5,
    },
    {
      name: "Bikaner",
      category: "Rajasthan",
      image: tour2,
      city: "Rajasthan",
      featured: true,
      reviews: 4.5,
    },
    {
      name: "Udaipur",
      category: "Rajastan",
      image: tour3,
      city: "Rajasthan",
      featured: true,
      reviews: 4.5,
    },
    {
      name: "Ajmer",
      category: "Rajasthan",
      image: tour4,
      city: "Rajasthan",
      featured: true,
      reviews: 4.5,
    },
    {
      name: "Ranthambore",
      category: "Rajasthan",
      city: "Rajasthan",
      image: tour5,
      featured: true,
      reviews: 4.5,
    },
    {
      name: "Jaisalmer",
      category: "Rajasthan",
      city:"Rajasthan",
      image: tour6,
      featured: true,
    },
    {
      name: "Bundi",
      category: "Rajasthan",
      image: tour7,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Ranakpur",
      category: "Rajasthan",
      image: tour8,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Barmer",
      category: "Rajasthan",
      image: tour9,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Shekhawati",
      category: "Rajasthan",
      image: tour10,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Dungarpur",
      category: "Rajasthan",
      image: tour11,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Bharatpur",
      category: "Rajasthan",
      image: tour12,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Karauli",
      category: "Rajasthan",
      image: tour13,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Jhalawpur",
      category: "Rajasthan",
      image: tour14,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Dholpur",
      category: "Rajasthan",
      image: tour15,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Chittorgarh",
      category: "Rajasthan",
      image: tour16,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Kumbhalpur",
      category: "Rajasthan",
      image: tour17,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Bhilwara",
      category: "Rajasthan",
      image: tour18,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Mount Abu",
      category: "Rajasthan",
      image: tour19,
      featured: true,
      city:"Rajasthan",
    },
    {
      name: "Jodhpur",
      category: "Rajasthan",
      image: tour20,
      featured: true,
      city:"Rajasthan",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <Helmet>
        <title>Top 20 Places to visit in Rajasthan - The Rustic Paths</title>
        <meta name="description" content="Explore our curated list of top 20 travel destinations in Rajasthan. Explore Now!" />
        <meta
          name="keywords"
          content="The Rustic Paths, book a driver in India, tour packages India, Golden Triangle Tour, South India Tour, Rajasthan Tour, Same Day Tour, Char Dham Tour, Short Tour"
        />
        {/* Add other meta tags as needed */}
      </Helmet>

      <section>
        <Container>
          <div className="details__info pt-0">
            <section>
              <Container>
                <Row>
                  <Col lg="12">
                    <h1 align="center" className="services__subtitle">
                      Popular Rajasthan Travel Destinations
                    </h1>
                  </Col>
                  <p className="para">
                    Welcome to the majestic land of Rajasthan, where every
                    corner whispers tales of valor, royalty, and vibrant
                    culture. Embark on a journey through time as you explore the
                    iconic forts and palaces that stand as a testament to
                    Rajasthan's glorious history. Lose yourself in the
                    labyrinthine streets of Jaipur, the Pink City, adorned with
                    magnificent palaces like the Hawa Mahal and the City Palace.
                    Traverse the golden sands of the Thar Desert on a camel
                    safari, immersing yourself in the timeless charm of rustic
                    villages and sprawling sand dunes that stretch as far as the
                    eye can see. Dive into the kaleidoscope of colors at the
                    Pushkar Camel Fair, a vibrant spectacle where traditions
                    come alive amidst the bustling market and spirited
                    festivities. Indulge your taste buds with the flavorsome
                    Rajasthani cuisine, a tantalizing fusion of spices and
                    culinary traditions that will leave you craving for more.{" "}
                    <br /> <br /> Whether you're captivated by the intricate
                    craftsmanship of Jodhpur's Mehrangarh Fort or enchanted by
                    the ethereal beauty of Udaipur's Lake Palace, Rajasthan
                    promises an unforgettable experience that will linger in
                    your memories long after you bid farewell to this enchanting
                    land. Let us craft a bespoke journey that will unveil the
                    secrets and splendors of Rajasthan, creating cherished
                    moments that will last a lifetime. With our customizable
                    Rajasthan tour packages and the convenience of a private
                    driver in India, allow us to guide you through this magical
                    realm, ensuring a seamless and unforgettable adventure.
                    Come, let the magic of Rajasthan weave its spell on you.
                  </p>
                  <Link to="/about">
                    <Button style={{ float: "right" }} className="primary__btn">
                      Know more...
                    </Button>
                  </Link>
                </Row>
              </Container>
            </section>
            {/*--------------------------- Tour Gallery --------------------------*/}
            <section>
              <Container>
                <ImageGallery images={images} />
              </Container>
            </section>
            {/*--------------------------- Tour Gallery End --------------------------*/}
            <section>
              <Container>
                <h1 className="services__subtitle mb-4">
                <Subtitle subtitle={"Popular Places In Rajasthan"} />
                </h1>
                <Row>
                  {/* Display TourCardBlock components */}
                  <Col lg="8" className="details__info">
                    <Row>
                      {tourData.map((tour, index) => (
                        <Col key={index} lg="4">
                          {isMobile ? (
                            <Slider {...settings}>
                              <div key={index}>
                                <TourCardBlock
                                  tour={tour}
                                  buttonText="Know More"
                                />
                              </div>
                            </Slider>
                          ) : (
                            <TourCardBlock
                              key={index}
                              tour={tour}
                              buttonText="Know More"
                            />
                          )}
                        </Col>
                      ))}
                    </Row>
                  </Col>
                  <Col
                    lg="4"
                    style={{
                      paddingRight: 0,
                      paddingLeft: window.innerWidth <= 768 ? 0 : "",
                    }}
                  >
                    <BookingMainPage />
                  </Col>
                </Row>
              </Container>
            </section>
            <p className="para">
              <Subtitle subtitle={"Why Choose Us"} textColor={"white"} />
              <li>
                {" "}
                Experienced Guides: Our team of experienced guides ensures a
                safe and memorable travel experience.{" "}
              </li>{" "}
              <li>
                {" "}
                Comfortable Accommodation: Stay in comfortable hotels, resorts,
                or guesthouses throughout your journey.
              </li>{" "}
              <li>
                Hassle-Free Travel: Sit back, relax, and let us take care of all
                the arrangements, from transportation to accommodation and
                sightseeing.
              </li>
            </p>
          </div>
        </Container>
        {/*--------------------------- Our Achievements Section Start--------------------------*/}
        <section>
          <Container>
            <Row>
              <Col lg="12">
                {/* <div style={{ backgroundColor: "#ffffff" }}>
                  <h2 align="center" className="services__subtitle">
                    Few of our achievements
                  </h2>
                </div> */}
                <Subtitle subtitle={"Few of our achievements"} />
              </Col>
              <Col lg="12">
                <AchievementsSection />
              </Col>
            </Row>
          </Container>
        </section>
      </section>

      {/*--------------------------- Our Achievements Section End--------------------------*/}
      <Newsletter />
    </>
  );
};

export default MainRajasthanTravel;
